import i18n from 'i18n';
import {isFieldRestrictedByKeys} from './fieldRegistry';

/**
 * Checks if a field is restricted.
 * Accepts either a flat restrictedFields array or restrictedFieldKeys (group IDs).
 */
export function isFieldRestricted(fieldName: string, restrictedFields: string[] | undefined | null): boolean {
    if (!restrictedFields || !restrictedFields.length) return false;
    if (restrictedFields.includes(fieldName)) return true;
    return isFieldRestrictedByKeys(fieldName, restrictedFields);
}

/**
 * Returns the display text for a restricted field.
 */
export function getRestrictedFieldPlaceholder(): string {
    return i18n.t('field_restricted_placeholder.text', {defaultValue: '[Restricted]'});
}

/**
 * Returns a CSS class for restricted field rendering.
 */
export function getRestrictedFieldClassName(): string {
    return 'text-muted';
}
